import { Box, Button, chakra, Text } from '@chakra-ui/react';
import AppCard from 'presentation/components/shared/card/AppCard';
import { Color } from 'presentation/theme/colorScheme';
import { ButtonVariant } from 'presentation/theme/components/button';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import AppRoute from 'router/AppRoute';

const EmptyProfileCard: FC = (props) => {
  const { t } = useTranslation();

  const navigate = useNavigate();

  return (
    <AppCard
      minH="130px"
      p="15px"
      display="flex"
      flexDirection="column"
      justifyContent="space-between"
      bgColor={Color.Shade500}
      bgImage="linear-gradient(180deg, #848484 0%, #323232 100%)"
      {...props}
    >
      <Text mb="10px" color="#fff">
        {t('fillTheProfile')}
      </Text>
      <Box>
        <Button
          variant={ButtonVariant.Light}
          onClick={() => navigate(AppRoute.profile)}
        >
          {t('fillTheProfileAction')}
        </Button>
      </Box>
    </AppCard>
  );
};

export default chakra(EmptyProfileCard);
